module.exports = __webpack_public_path__ + "img/shequfengcai.2e32c40b.png";